import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../../manager'
import CreationToolUploadField from '../../../../../types/upload-field'
import CreationToolUserRestriction from '../../../../../types/user-restriction'
import { GridBlock } from '../../../../blocks'
import TagsField from './fields/tags'
import UsernameField from './fields/username'
import SourceURLField from './fields/source-url'
import RatingField from './fields/rating'
import PrivacyField from './fields/privacy'
import VideoDescriptionField from './fields/video-description'
import MetadataDescription from './fields/metadata-description'

const FIELDS = [
    CreationToolUploadField.Privacy,
    CreationToolUploadField.VideoDescription,
    CreationToolUploadField.Tags,
    CreationToolUploadField.Username,
    CreationToolUploadField.SourceUrl,
    CreationToolUploadField.Rating,
]

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoMetadata = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)

    // filter out any fields that the user doesn't have access to.
    const fields = FIELDS.filter((field) => {
        const userRestriction = CreationToolUploadField.userRestriction(field)
        return CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
    })

    const fieldComponents = fields.map((field) => {
        switch (field) {
            case CreationToolUploadField.Privacy:
                return PrivacyField
            case CreationToolUploadField.VideoDescription:
                return VideoDescriptionField
            case CreationToolUploadField.Tags:
                return TagsField
            case CreationToolUploadField.Username:
                return UsernameField
            case CreationToolUploadField.SourceUrl:
                return SourceURLField
            case CreationToolUploadField.Rating:
                return RatingField
        }
    })

    return (
        <Fields columns={2}>
            <MetadataDescription />
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoMetadata
